// Shared "Account name" field for the connect modals' "add another account"
// flow. Owns the label, placeholder, help text, and length cap so that copy
// stays consistent between the OAuthIntegrationPairingModal and the
// DiscoveredUrlPairingModal. Each modal passes its own `inputClassName` so the
// field matches that modal's existing input styling.

interface AccountNameFieldProps {
  id: string;
  value: string;
  onChange: (value: string) => void;
  // Labels already connected — listed in the help text so the user knows what
  // they're distinguishing this account from.
  existingLabels: string[];
  inputClassName: string;
  disabled?: boolean;
}

export function AccountNameField({
  id,
  value,
  onChange,
  existingLabels,
  inputClassName,
  disabled = false,
}: AccountNameFieldProps) {
  return (
    <div>
      <label
        htmlFor={id}
        className="block text-sm font-medium text-gray-700"
      >
        Account name
      </label>
      <input
        id={id}
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder="e.g. Work, Personal"
        maxLength={64}
        className={inputClassName}
        disabled={disabled}
      />
      <p className="mt-1 text-xs text-gray-500">
        Give this account a name so you (and your assistant) can tell it apart
        from {existingLabels.join(', ')}.
      </p>
    </div>
  );
}
